import React from 'react';
import { bool, func, string } from 'prop-types';
import styled, { css } from 'styled-components';
import { Typography, ImageBackground, Flex } from '@atoms';

const MenuCategory = ({
  imageSrc,
  title,
  onCategorySelect,
  isActive,
}) => (
  <Wrapper
    isActive={isActive}
    column
    padding="md"
    justifyBetween={!isActive}
    justifyEnd={isActive}
    imageSrc={imageSrc}
    onClick={onCategorySelect}
  >
    {!isActive && (
      <InactiveItemMessageWrapper justifyCenter itemsCenter grow={0}>
        <Typography color="white" size="sm">
          Category is inactive
        </Typography>
      </InactiveItemMessageWrapper>
    )}
    <StyledTypography size="xl3" weight="black" color="white">
      {title}
    </StyledTypography>
  </Wrapper>
);

const Wrapper = styled(ImageBackground)`
  ${({ theme: { color }, isActive }) => css`
    width: 50%;
    max-width: 50%;
    height: 55vw;
    border: 1px solid ${color.warmGrey};
    border: ${isActive ? `1px solid ${color.warmGrey}` : `2px solid ${color.strawberry}`};
  `}
`;

const InactiveItemMessageWrapper = styled(Flex)`
  ${({ theme: { color } }) => css`
    width: 120px;
    height: 20px;
    border-radius: 10px;
    background-color: ${color.strawberry};
  `}
`;

const StyledTypography = styled(Typography)`
  ${({ theme: { color } }) => css`
    text-shadow: 1px 1px ${color.black};
  `}
`;

MenuCategory.defaultProps = {
  imageSrc: '',
  isActive: true,
};

MenuCategory.propTypes = {
  isActive: bool,
  imageSrc: string,
  title: string.isRequired,
  onCategorySelect: func.isRequired,
};

export default MenuCategory;
